const OfferWidget = (props: any) => {
  return <div className="offer-banner-widget" dangerouslySetInnerHTML={{ __html: props.data.bodyHtml }} />;
};

export default OfferWidget;
